import React from 'react';

import classNames from 'classnames';

export const selectClassName =
    'tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/50 tw-text-charcoal tw-font-semibold placeholder:tw-text-charcoal-75 placeholder:tw-text-sm placeholder:tw-font-normal';

export const SELECT_BACKGROUND = '#e4e4e480';

/**
 * One builder setting: its label and a line of help on the start side, the
 * control on the end side. `stacked` puts a wide control under the label.
 */
export const SettingRow = ({ label, help, htmlFor, error, stacked = false, children }) => (
    <div className="tw-py-4 tw-border-b tw-border-charcoal-15 last:tw-border-b-0">
        <div className={classNames('tw-flex tw-gap-4', stacked ? 'tw-flex-col tw-gap-2' : 'tw-items-start tw-justify-between')}>
            <div className="tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0">
                <label className="tw-text-sm tw-font-semibold tw-text-charcoal tw-mb-0" htmlFor={htmlFor}>
                    {label}
                </label>
                {help && <span className="tw-text-xs tw-text-charcoal-75">{help}</span>}
            </div>
            <div className={stacked ? 'tw-w-full' : 'tw-w-44 tw-shrink-0'}>{children}</div>
        </div>
        {error && <div className="tw-text-red-500 tw-text-sm tw-mt-1.5">{error}</div>}
    </div>
);

/**
 * A labelled control with the label above it.
 */
const FormField = ({ label, htmlFor, error, children }) => (
    <div className="tw-flex tw-flex-col tw-space-y-1.5">
        <label className="text-input__label" htmlFor={htmlFor}>
            {label}
        </label>
        {children}
        {error && <div className="tw-text-red-500 tw-text-sm">{error}</div>}
    </div>
);

export default FormField;
